import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { EconomyService, ValutaItem } from '../../../services/economy.service';
import { TypeaheadService } from '../../../services/typeahead.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-factoring',
  templateUrl: './factoring.component.html',
  styleUrls: ['./factoring.component.css']
})
export class FactoringComponent implements OnInit {
    factoringNo;

    public edit?: Edit;

    public selectListAccounts: AccountItem[] = [];

    public selectListCurrencies: ValutaItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private economy: EconomyService, private typeahead: TypeaheadService) {
        this.factoringNo = this.stateService.getStateParams()['factoring_no'];
    }

    private async loadEdit() {
        if (!!this.factoringNo) {
            this.edit = (await this.datatask.Post(3464, { factoring_no: this.factoringNo }))[0];
        }
    }

    private async loadAccounts(): Promise<void> {
        this.selectListAccounts = await this.datatask.Post(3466);
    }

    private async loadCurrencies(): Promise<void> {
        this.selectListCurrencies = await this.economy.getValutas();
    }

    public searchCustomerNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.edit?.cust_name ?? '',
            custtype: 'A',
            lastselect: 'SEARCH'
        });
    }

    public async onCustomerNameSelected(item?: Item) {
        if (!!this.edit) {
            this.edit.factoring_cust_no = item?.item_id ?? '0';
            this.edit.cust_name = item?.item_name ?? '';
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3465, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadAccounts();
        this.loadCurrencies();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    factoring_no: number;
    factoring_name: string;
    account_no: number;
    clientno: number;
    client_valuta_id: string;
    factoring_cust_no: string | number;
    cust_name: string;
    factoring_note: string;
    bank_account: string;
    interval: number;
}

interface AccountItem {
    account_no: number;
    account_no_and_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('factoring', {
//        templateUrl: 'views/components/views/factoring/factoring.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'factoringService', 'economyService', 'typeaheadService', function ($stateParams, stateService, translateService, modalService, factoringService, economyService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let factoringNo = $stateParams.factoring_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListCurrencies: [],
//                selectListAccounts: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            let loadEdit = function () {
//                factoringService.getEdit({ factoring_no: factoringNo }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            };

//            let loadCurrencies = function () {
//                economyService.listCurrencies().then(function (list) {
//                    angular.copy(list, vm.model.selectListCurrencies);
//                });
//            };

//            let loadAccounts = function () {
//                factoringService.listAccounts().then(function (list) {
//                    angular.copy(list, vm.model.selectListAccounts);
//                });
//            };

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.searchCustomer({
//                            cust_name: vm.model.edit[id] || '',
//                            filtertype: '',
//                            filtervalue: '',
//                            custtype: 'A',
//                            lastselect: 'SEARCH'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'cust_name':
//                        if (item) {
//                            vm.model.edit.factoring_cust_no = item?.item_id ?? '';
//                            vm.model.edit.cust_name = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('cust_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.edit.cust_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.factoring_cust_no = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('cust_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.edit.factoring_cust_no = '';
//                        vm.model.edit.cust_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                factoringService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//                loadCurrencies();
//                loadAccounts();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
